// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"NextGenInfo_TheComp__BMBp5"};